import React, { useRef, useCallback } from 'react'

import withTranslate from 'react-redux-multilingual/lib/withTranslate'

import { Paper, Grid, withStyles, Typography, Box, Button } from '@material-ui/core'
import { CloudUploadRounded } from '@material-ui/icons'
import LoadingIndicator from './LoadingIndicator/LoadingIndicator'

const FileDropper = ({
  currentFile,
  uploadProgress,
  acceptFormat = '',
  fileChanged,
  styleConfig = { iconSize: 72, height: 300 },
  loading = false,
  translate
}) => {
  const fileInputRef = useRef(null)
  const fileName = currentFile?.name || ''
  const fileSize = currentFile?.size || ''

  const browseFileClickHandler = useCallback(() => {
    if (!loading) {
      fileInputRef.current.click()
    }
  }, [fileInputRef, loading])

  const fileChangedHandler = useCallback(
    e => {
      const preservedEvent = { ...e }
      if (!loading) {
        e.preventDefault()
        e.stopPropagation()
        fileChanged(preservedEvent)
      }
    },
    [fileChanged, loading]
  )

  const preventNativeEventHandler = useCallback(e => {
    e.preventDefault()
    e.stopPropagation()
  }, [])

  const fileInfo = currentFile ? (
    <Box>
      <Typography variant={'subtitle1'}>
        {fileName} ({fileSize})
      </Typography>
    </Box>
  ) : null

  return (
    <MaximizedPaper elevation={3} height={styleConfig.height}>
      <input
        ref={fileInputRef}
        type={'file'}
        accept={acceptFormat}
        onChange={fileChangedHandler}
        hidden
      />
      <DashedBox
        height={styleConfig.height}
        component={Button}
        onClick={browseFileClickHandler}
        onDrop={fileChangedHandler}
        onDragOver={preventNativeEventHandler}
        onDragEnter={preventNativeEventHandler}
        onDragLeave={preventNativeEventHandler}>
        <Grid container direction={'column'} alignItems={'center'} justify={'center'}>
          <Grid item>
            <CloudUploadRounded style={{ fontSize: styleConfig.iconSize || 60 }} />
          </Grid>
          <Grid item>
            <Typography color={'inherit'} variant={'h5'}>
              {translate('import')}
            </Typography>
            <Typography paragraph color={'inherit'} variant={'body2'}>
              {translate('browseOrDropFileHere')}
            </Typography>
            <LoadingIndicator show={loading} fileInfo={fileInfo} progress={uploadProgress} />
          </Grid>
        </Grid>
      </DashedBox>
    </MaximizedPaper>
  )
}

const MaximizedPaper = withStyles(theme => ({
  root: { height: '100%', minHeight: 300, padding: theme.spacing(2) }
}))(Paper)

const DashedBox = withStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
    minHeight: 350,
    color: theme.palette.success.light,
    background: theme.palette.background.default,
    padding: theme.spacing(2),
    borderColor: theme.palette.success.light,
    borderWidth: 4,
    borderRadius: theme.shape.borderRadius,
    borderStyle: 'dashed'
  }
}))(Box)

export default withTranslate(FileDropper)
